import { makeStyles } from "@material-ui/styles";

export default makeStyles((theme) => ({
  tableCell: {
    display: "flex",
    paddingTop: '10px',
    paddingBottom: '10px',
    alignContent: "center",
    alignItems: "center",
    cursor: "pointer",
    fontSize: "12px !important",
    fontWeight: 500,
    padding: "0px 2px",
    textAlign: "center",
   
  },
  imgAvtar: {
    marginRight: "10px",
  },
  tableHeadCell: {
    fontSize: "14px !important",
    fontWeight: 700,
    textTransform: "uppercase",
    color:'#201F1E'
  },
  tableBodyCell: {
    fontSize: "12px !important",
    fontWeight: 500,
    padding: "0px 2px",
    textAlign: "center",
    
  },
}));
